<template>
  <div class="columns mt-0 mr-0">
    <div class="column">
      {{ classification.ml_class.name }}
    </div>
    <div class="column is-narrow p-0">
      <ConfidenceTag :value="classification.confidence" />
      <div class="tags has-addons ml-1">
        <span
          :disabled="disabled || loading || null"
          class="tag button icon-trash has-text-danger"
          :class="{ 'is-loading': loading }"
          title="Delete this classification"
          v-on:click="remove"
        ></span>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { mapStores } from 'pinia'
import { type PropType, defineComponent } from 'vue'

import ConfidenceTag from '@/components/ConfidenceTag.vue'
import { useClassificationStore } from '@/stores'
import type { Classification, UUID } from '@/types'

export default defineComponent({
  components: {
    ConfidenceTag,
  },
  props: {
    classification: {
      type: Object as PropType<Classification>,
      required: true,
    },
    elementId: {
      type: String as PropType<UUID>,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    loading: false,
  }),
  computed: {
    ...mapStores(useClassificationStore),
  },
  methods: {
    async remove() {
      if (this.disabled || this.loading) return
      this.loading = true
      try {
        await this.classificationStore.delete(this.classification.id, this.elementId)
      } finally {
        this.loading = false
      }
    },
  },
})
</script>

<style scoped>
.column {
  padding-top: 0;
  padding-bottom: 0;
  display: flex;
  align-items: center;
}
.button.icon-trash {
  width: 2em;
}
</style>
